export default __webpack_public_path__ + "static/media/feature-icon-02.4f1f5f7f.svg";